module.exports = "\n{{ message }}\n"